export default "__VITE_PUBLIC_ASSET__4cf41cd5__"